// src/pages/ProductDetail.js
import {React, useState, useEffect} from "react";
import { useParams, Link } from "react-router-dom";
import "./ProductDetail.css";

import LD1 from "../assets/images/LD-250W.png";
import LD2 from "../assets/images/LD-250W_RF.png";
import LD3 from "../assets/images/LD-250W_BST.png";
import LD4 from "../assets/images/LD-RGB_BST.png";
import LD5 from "../assets/images/LD-RGB.png";
import DM1 from "../assets/images/DM-400LN.jpg";
import DM2 from "../assets/images/DM-1000W.jpg";
import DM3 from "../assets/images/DM-400B.png";
import DM4 from "../assets/images/DM-400B-RF.png";
import DM5 from "../assets/images/DM-300B.png";
import DM6 from "../assets/images/DM-DGL-B.png";
import DM7 from "../assets/images/DM-2500W.jpg";
import DM8 from "../assets/images/DM-2500.jpg";
import DM9 from "../assets/images/DM-PRO.jpg";
import SW1 from "../assets/images/SW-1CHL.png";
import SW2 from "../assets/images/SW-6CHL.png";
import SW3 from "../assets/images/SD-1CHL.png";
import SW4 from "../assets/images/SW-400B.png";
import SW5 from "../assets/images/SD-400B.png";
import SW6 from "../assets/images/SD-V10.png";
import SW7 from "../assets/images/SD-V10R.png";
import SW8 from "../assets/images/SD-250W.png";
import SW9 from "../assets/images/SD-RGB.png";
import SW10 from "../assets/images/SD-LCD.png";
import SW11 from "../assets/images/SB-ROLL.png";
import SW12 from "../assets/images/SW-IR40.jpg";
import SW13 from "../assets/images/ST-520R.png";
import SW14 from "../assets/images/ST-520-RV.png";
import SW15 from "../assets/images/ST-520FC.webp";
import Sw16 from "../assets/images/mobile.jpg";
import SW17 from "../assets/images/browser.jpg";

// ================== PRODUCT DATA ==================
const productData = {
  "sw-1chl": {
    name: "RAIL-MOUNTED SMART SWITCH 1 CHANNEL 230 VAC / 8A (Wi-Fi)",
    image: SW1,
    description: (
      <>
        <p>The 
          <b> Rail-mounted switch SW-1CHL</b> (smart switch / 1 channel) is a cutting-edge product of the MASTER Smart Home line, suitable for controlling and managing (on-off) your lighting and electrical  appliances.
        </p>
        <p>Automate, control and inspect the state of your electrical appliances while reducing your household costs, with the ability to operate locally via buttons and online via internet or Wi-Fi using smartphone, tablet or PC. The following user manual will help you install the MASTER Smart Home app for Android or iOS and enjoy the “smart” lighting control functions.</p>
        <p><br/>
          <b>Features:</b>
        <br/></p>
        <ul>
          <li>Visualization, control and management of lighting and electrical appliances (on - off)</li>
          <li>User-friendly, easy-to-use interface</li>
          <li>Works with Google Assistant and Amazon Alexa</li>
          <li>Secure connection to Wi-Fi</li>
          <li>No hub/gateway is required</li>
          <li>Timer function</li>
          <li>Time-schedules</li>
          <li>Maximum economy and comfort through smart scenes</li>
          <li>Low implementation cost in existing or new installations</li>
          <li>Remote control via Wi-Fi and Internet with the “MASTER Smart Home” app for smartphone, tablet and PC and local control via button</li>
        </ul>

        <div className="technical-specs">
          <h3>Technical Specifications</h3>
          <p><b>RAIL-MOUNTED SWITCH (1 MODULE):</b> 1 Channel (Relay)</p>
          <p><b>OPERATING VOLTAGE:</b> 180-230V AC</p>
          <p><b>OUTPUT POWER:</b> 1840W / 8A max</p>
          <p><b>OUTPUT POWER BOOST: </b>The output power of the product can be extended by adding the corresponding power relay according to the electric load</p>
          <p><b>STAND BY CONSUMPTION: </b>≤ 1W</p>
          <br/>
          <p><b>CONTROL :</b></p>
          <ul>
            <li>Local: ON/OFF from the device</li>
            <li>Button: With one or more parallel buttons - (ON/OFF) with instant push</li>
            <li>Remote: With the MASTER Smart Home app for smartphones or tablets over Wi-Fi or Data</li>
          </ul><br/>
          <p><b>ENVIRONMENT TEMPERATURE:</b> -20°C until +50°C</p>
          <p><b>WIRE SIZE:</b> From Ø0.5 mm to Ø3.5 mm</p>
          <p>
            <b>Mounting :</b> Din-rail mounting 35x7.5mm (DIN 45277)
          </p>
        </div>
      </>
    ),
  },
  "sw-6chl": {
    name: "RAIL-MOUNTED SMART SWITCH 6 CHANNEL 230 VAC / 6*10A (Wi-Fi)",
    image: SW2,
    description: (
      <>
        <p>The 
          <b> Rail-mounted switch SW-6CHL</b> (smart switch / 6 channel) is a cutting-edge product of the MASTER Smart Home line, suitable for controlling and managing (on-off) your lighting and electrical appliances. Installation of the SW-6CHL on the electrical panel enables ON/OFF capabilities in 6 different sections of an electrical installation. Its high-definition liquid crystal display, the local and remote control of lighting or electrical appliances combined with data visualization make it unique.
        </p>
        <p>Automate, manage and control the state of your lighting and appliances in your home and business environment, operating locally via buttons and remotely over internet or Wi-Fi using smartphone, tablet or PC with the MASTER Smart Home application. The following user manual will help you install the “MASTER Smart Home” app for Android or iOS and enjoy the “smart” lighting control functions.</p>
        <p><br/>
          <b>Features:</b>
        <br/></p>
        <ul>
          <li>Visualization, control and management of lighting and electrical appliances (on - off)</li>
          <li>User-friendly, easy-to-use interface</li>
          <li>Works with Google Assistant and Amazon Alexa</li>
          <li>Secure connection to Wi-Fi</li>
          <li>No hub/gateway is required</li>
          <li>Timer function</li>
          <li>Time-schedules</li>
          <li>Maximum economy and comfort through smart scenes</li>
          <li>Low implementation cost in existing or new installations</li>
          <li>Remote control via Wi-Fi and Internet with the “MASTER Smart Home” app for smartphone, tablet and PC and local control via button</li>
        </ul>

        <div className="technical-specs">
          <h3>Technical Specifications</h3>
          <p><b>RAIL-MOUNTED SWITCH (6 MODULE):</b> 6 Channel (Relay)</p>
          <p><b>OPERATING VOLTAGE:</b> 180-230V AC</p>
          <p><b>OPERATING FREQUENCY :</b> 50Hz</p>
          <p><b>OUTPUT POWER:</b> 2300W / 10A max</p>
          <p><b>OUTPUT POWER BOOST: </b>The output power of the product can be extended by adding the corresponding power relay according to the electric load</p>
          <p><b>STAND BY CONSUMPTION: </b>≤ 1W</p>
          <br/>
          <p><b>CONTROL :</b></p>
          <ul>
            <li>Local: ON/OFF from the device</li>
            <li>Button: With one or more parallel buttons - (ON/OFF) with instant push</li>
            <li>Remote: With the MASTER Smart Home app for smartphones or tablets over Wi-Fi or Data</li>
          </ul><br/>
          <p><b>ENVIRONMENT TEMPERATURE:</b> -20°C until +50°C</p>
          <p><b>WIRE SIZE:</b> From Ø0.5 mm to Ø3.5 mm</p>
          <p>
            <b>Mounting :</b> Din-rail mounting 35x7.5mm (DIN 45277)
          </p>
        </div>
      </>
    ),
  },
  "sd-1chl": {
    name: "RAIL-MOUNTED SMART DIMMER 1 CHANNEL 230 VAC / 300W (Wi-Fi)",
    image: SW3,
    description: (
      <>
        <p>The 
          <b> Rail-mounted smart Dimmer SD-1CHL</b> (1 channel) is a cutting-edge product of the MASTER Smart Home line, suitable for controlling lighting intensity using alternative types of lamps like Filament LED, Dimmable LED as well as older types of lamps (Halogen).
        </p>
        <p>The output power of the product can be expanded indefinitely by adding amplifiers thereby making any electrical application possible. Adjust the lighting intensity, create an atmosphere and save energy, operating locally via buttons and remotely over internet and Wi-Fi using smartphone, tablet or PC with the MASTER Smart Home app. The following user manual will help you install the “MASTER Smart Home” app for Android or iOS and enjoy the “smart” lighting control functions.</p>
        <p><br/>
          <b>Features:</b>
        <br/></p>
        <ul>
          <li>Visualization, control and management of lighting and electrical appliances (on - off)</li>
          <li>User-friendly, easy-to-use interface</li>
          <li>Works with Google Assistant and Amazon Alexa</li>
          <li>Secure connection to Wi-Fi</li>
          <li>No hub/gateway is required</li>
          <li>Leading - Trailing Edge and Soft Start functions</li>
          <li>Setting of brightness lower limit</li>
          <li>Time-schedules</li>
          <li>Maximum economy and comfort through smart scenes</li>
          <li>Low implementation cost in existing or new installations</li>
          <li>Remote control via Wi-Fi and Internet with the “MASTER Smart Home” app for smartphone, tablet and PC and local control via button</li>
        </ul>

        <div className="technical-specs">
          <h3>Technical Specifications</h3>
          <p><b>RAIL-MOUNTED SWITCH (1 MODULE):</b> Digital (IGBT) - LED / 1 Channel</p>
          <p><b>OPERATING VOLTAGE:</b> 180-230V AC</p>
          <p><b>OPERATING FREQUENCY :</b> 50Hz</p>
          <p><b>OUTPUT POWER:</b> 3000W / RC</p>
          <p><b>OUTPUT POWER BOOST: </b> The output power of the product can be expanded indefinitely by adding the amplifiers DM-CHL(rail) with output power 1000W / 230 VAC each.</p>
          <p><b>STAND BY CONSUMPTION: </b>≤ 1W</p>
          <p><b>Function : </b>Soft - Start </p>
          <p><b>MODE OF OPERATION :</b> Leading Edge - Trailing Edge (with the MASTER Smart Home app)</p>
          <p><b>Fuse : </b>Electronic (overheating and overvoltage protection with automatic reset to operation)</p>
          <p><b>Lower limit setting : </b>SD-1CHL enables the user to preset the minimum brightness of the dimmable LED lamps if required. This process is achieved through the MASTER Smart Home application. </p>
          <br/>
          <p><b>CONTROL :</b></p>
          <ul>
            <li>Local: ON/OFF from the device</li>
            <li>Button: With one or more parallel buttons - (ON/OFF) with instant push</li>
            <li>Remote: With the MASTER Smart Home app for smartphones or tablets over Wi-Fi or Data</li>
          </ul><br/>
          <p><b>ENVIRONMENT TEMPERATURE:</b> -20°C until +50°C</p>
          <p><b>WIRE SIZE:</b> From Ø0.5 mm to Ø3.5 mm</p>
          <p>
            <b>Mounting :</b> Din-rail mounting 35x7.5mm (DIN 45277)
          </p>
        </div>
      </>
    ),
  },
  "sw-400b": {
    name: "FLUSH-MOUNTED SMART SWITCH 230 VAC / 400W (Wi-Fi)",
    image: SW4,
    description: (
      <>
        <p>The 
          <b> Flush-mounted switch SW-400B</b> (1 channel) is a cutting-edge product of the MASTER Smart Home line, suitable for controlling and managing (on-off) your lighting and electrical appliances.
        </p>
        <p>Its placement in the junction box and its control locally by one or more parallel buttons of any type or company, make the SW-400B dimmer unique. Automate, control and inspect the state of your electrical appliances. The following user manual will help you install the “MASTER Smart Home” app for Android or iOS and enjoy the “smart” lighting control functions.</p>
        <p><br/>
          <b>Features:</b>
        <br/></p>
        <ul>
          <li>Visualization, control and management of lighting and electrical appliances (on - off)</li>
          <li>User-friendly, easy-to-use interface</li>
          <li>Works with Google Assistant and Amazon Alexa</li>
          <li>Secure connection to Wi-Fi</li>
          <li>No hub/gateway is required</li>
          <li>Timer function</li>
          <li>Time-schedules</li>
          <li>Maximum economy and comfort through smart scenes</li>
          <li>Low implementation cost in existing or new installations</li>
          <li>Remote control via Wi-Fi and Internet with the “MASTER Smart Home” app for smartphone, tablet and PC and local control via button</li>
        </ul>

        <div className="technical-specs">
          <h3>Technical Specifications</h3>
          <p><b>FLUSH-MOUNTED SWITCH : </b> 1 Channel (Electronic)</p>
          <p><b>OPERATING VOLTAGE:</b> 180-230V AC</p>
          <p><b>OPERATING FREQUENCY :</b> 50Hz</p>
          <p><b>OUTPUT POWER:</b> 400W</p>
          <p><b>OUTPUT POWER BOOST: </b>The output power of the product can be extended by adding the corresponding power relay according to the electric load</p>
          <p><b>STAND BY CONSUMPTION: </b>≤ 1W</p>
          <br/>
          <p><b>CONTROL :</b></p>
          <ul>
            <li>Button: With one or more parallel buttons - (ON/OFF) with instant push</li>
            <li>Remote: With the MASTER Smart Home app for smartphones or tablets over Wi-Fi or Data</li>
          </ul><br/>
          <p><b>ENVIRONMENT TEMPERATURE:</b> -20°C until +50°C</p>
          <p><b>WIRE SIZE:</b> From Ø0.5 mm to Ø3.5 mm</p>
          <p>
            <b>Mounting :</b> Din-rail mounting 35x7.5mm (DIN 45277)
          </p>
        </div>
      </>
    ),
  },
  "sd-400b": {
    name: "SMART FLUSH-MOUNTED DIMMER 230 VAC / 300W (Wi-Fi)",
    image: SW5,
    description: (
      <>
        <p>The 
          <b> Flush-mounted smart Dimmer SD-400B</b> (1 channel) is a cutting-edge product of the MASTER Smart Home line, suitable for controlling lighting intensity, using alternative types of lamps like Filament LED, Dimmable LED as well as older types of lamps (Halogen).
        </p>
        <p>(1 channel) is a cutting-edge product of the MASTER Smart Home line, suitable for controlling lighting intensity, using alternative types of lamps like Filament LED, Dimmable LED as well as older types of lamps (Halogen).</p>
        <p><br/>
          <b>Features:</b>
        <br/></p>
        <ul>
          <li>Visualization, control and management of lighting and electrical appliances (on - off)</li>
          <li>User-friendly, easy-to-use interface</li>
          <li>Works with Google Assistant and Amazon Alexa</li>
          <li>Secure connection to Wi-Fi</li>
          <li>No hub/gateway is required</li>
          <li>Leading - Trailing Edge and Soft Start functions</li>
          <li>Setting of brightness lower limit</li>
          <li>Time-schedules</li>
          <li>Maximum economy and comfort through smart scenes</li>
          <li>Low implementation cost in existing or new installations</li>
          <li>Remote control via Wi-Fi and Internet with the “MASTER Smart Home” app for smartphone, tablet and PC and local control via button</li>
        </ul>

        <div className="technical-specs">
          <h3>Technical Specifications</h3>
          <p><b>DIMMER : </b> Digital (IGBT) - LED / 1 Channel</p>
          <p><b>OPERATING VOLTAGE:</b> 180-230V AC</p>
          <p><b>OPERATING FREQUENCY :</b> 50Hz</p>
          <p><b>OUTPUT POWER:</b> 3000W / RC</p>
          <p><b>OUTPUT POWER BOOST: </b> The output power of the product can be expanded indefinitely by adding the amplifiers DM-CHL(rail) with output power 1000W / 230 VAC each.</p>
          <p><b>STAND BY CONSUMPTION: </b>≤ 1W</p>
          <p><b>Function : </b>Soft - Start </p>
          <p><b>MODE OF OPERATION :</b> Leading Edge - Trailing Edge (with the MASTER Smart Home app)</p>
          <p><b>Fuse : </b>Electronic (overheating and overvoltage protection with automatic reset to operation)</p>
          <p><b>Lower limit setting : </b>SD-400B enables the user to preset the minimum brightness of the dimmable LED lamps if required. This process is achieved through the MASTER Smart Home application. </p>
          <br/>
          <p><b>CONTROL :</b></p>
          <ul>
            <li>Button: With one or more parallel buttons - (ON/OFF) with instant push</li>
            <li>Remote: With the MASTER Smart Home app for smartphones or tablets over Wi-Fi or Data</li>
          </ul><br/>
          <p><b>ENVIRONMENT TEMPERATURE:</b> -20°C until +50°C</p>
          <p><b>WIRE SIZE:</b> From Ø0.5 mm to Ø3.5 mm</p>
          <p>
            <b>Mounting :</b> Din-rail mounting 35x7.5mm (DIN 45277)
          </p>
        </div>
      </>
    ),
  },
  "sd-v10": {
    name: "SMART DIMMER 1-10V / 50mA (Wi-Fi)",
    image: SW6,
    description: (
      <>
        <p>The 
          <b> Smart Dimmer SD-V10</b> (1 channel) is a cutting-edge product of the MASTER Smart Home line. It is suitable for managing and controlling devices that support the 1-10V protocol, like dimmable LED Panels and Inverters for electric motor control.
        </p>
        <p>Adjust the intensity of lighting or the speed of electric motors with linear and stable operation. Can be controlled locally with a push-button and remotely via the MASTER Smart Home application over internet or WiFi. The following user manual will help you install the “MASTER Smart Home” app for Android or iOS and enjoy the “smart” lighting control functions.</p>
        <p><br/>
          <b>Features:</b>
        <br/></p>
        <ul>
          <li>Visualization, control and management of lighting and electrical appliances (on - off)</li>
          <li>User-friendly, easy-to-use interface</li>
          <li>Works with Google Assistant and Amazon Alexa</li>
          <li>Secure connection to Wi-Fi</li>
          <li>No hub/gateway is required</li>
          <li>Timer function</li>
          <li>Time-schedules</li>
          <li>Maximum economy and comfort through smart scenes</li>
          <li>Low implementation cost in existing or new installations</li>
          <li>Remote control via Wi-Fi and Internet with the “MASTER Smart Home” app for smartphone, tablet and PC and local control via button</li>
        </ul>

        <div className="technical-specs">
          <h3>Technical Specifications</h3>
          <p><b>DIMMER : </b> Electronic 1-10V</p>
          <p><b>OPERATING VOLTAGE:</b> 180-230V AC</p>
          <p><b>OUTPUT SIGNAL:</b> 1-10V / 50mA</p>
          <br/>
          <p><b>Control : </b></p>
          <ul>
            <li>Drivers</li>
            <li>Controllers (Electronic ballasts with 1-10V protocol)</li>
          </ul><br/>
          <p><b>CONTROL :</b></p>
          <ul>
            <li>Button: With one or more parallel buttons - (ON/OFF) with instant push</li>
            <li>Remote: With the MASTER Smart Home app for smartphones or tablets over Wi-Fi or Data</li>
          </ul><br/>
          <p><b>ENVIRONMENT TEMPERATURE:</b> -20°C until +50°C</p>
          <p><b>WIRE SIZE:</b> From Ø0.5 mm to Ø3.5 mm</p>
        </div>
      </>
    ),
  },
  "sd-v10r": {
    name: "RAIL-MOUNTED SMART DIMMER 0/1-10V (Wi-Fi)",
    image: SW7,
    description: (
      <>
        <p>The 
          <b> Smart Dimmer SD-V10-R</b> (1 channel) is a cutting-edge product of the MASTER Smart Home line. It is suitable for managing and controlling devices that support the 0/1-10V protocol, like dimmable LED Panels and Inverters for electric motor control.
        </p>
        <p>Adjust the intensity of lighting or the speed of electric motors with linear and stable operation. Can be controlled locally with a push-button and remotely via the MASTER Smart Home application over internet or WiFi. The following user manual will help you install the “MASTER Smart Home” app for Android or iOS and enjoy the “smart” lighting control functions.</p>
        <p><br/>
          <b>Features:</b>
        <br/></p>
        <ul>
          <li>Visualization, control and management of lighting and electrical appliances (on - off)</li>
          <li>User-friendly, easy-to-use interface</li>
          <li>Works with Google Assistant and Amazon Alexa</li>
          <li>Secure connection to Wi-Fi</li>
          <li>No hub/gateway is required</li>
          <li>Timer function</li>
          <li>Time-schedules</li>
          <li>Maximum economy and comfort through smart scenes</li>
          <li>Low implementation cost in existing or new installations</li>
          <li>Remote control via Wi-Fi and Internet with the “MASTER Smart Home” app for smartphone, tablet and PC and local control via button</li>
        </ul>

        <div className="technical-specs">
          <h3>Technical Specifications</h3>
          <p><b>DIMMER : </b> Electronic 1-10V</p>
          <p><b>OPERATING VOLTAGE:</b> 180-230V AC</p>
          <p><b>OUTPUT SIGNAL:</b> 0/1-10V (50mA max)</p>
          <br/>
          <p><b>Control : </b></p>
          <ul>
            <li>Drivers</li>
            <li>Controllers (Electronic ballasts with 1-10V protocol)</li>
          </ul><br/>
          <p><b>CONTROL :</b></p>
          <ul>
            <li>Button: With one or more parallel buttons - (ON/OFF) with instant push</li>
            <li>Remote: With the MASTER Smart Home app for smartphones or tablets over Wi-Fi or Data</li>
          </ul><br/>
          <p><b>ENVIRONMENT TEMPERATURE:</b> -20°C until +50°C</p>
          <p><b>WIRE SIZE:</b> From Ø0.5 mm to Ø3.5 mm</p>
          <p><b>Lower limit setting: </b>SD-V10 enables the user to preset the minimum brightness of the dimmable LED lamps if required. This process is achieved through the MASTER Smart Home application. </p>
        </div>
      </>
    ),
  },
  "sd-250w": {
    name: "SMART LED CONTROLLER 12-24 VDC / 21A 1CHANNEL (Wi-Fi)",
    image: SW8,
    description: (
      <>
        <p>The 
          <b> Smart LED Controller SD-250W</b> (1 channel) is a cutting-edge product of the MASTER Smart Home line, suitable for managing and controlling lighting intensity of 12-24V DC LED strips. The output power of the product can be expanded indefinitely by adding amplifiers thereby making any electrical application possible.
        </p>
        <p>Adjusting the intensity of your hidden lighting locally with a push-button, 1-10V protocol and remotely via the MASTER Smart Home app provides the ultimate comfort. The following user manual will help you install the “MASTER Smart Home” app for Android or iOS and enjoy the “smart” lighting control functions.</p>
        <p><br/>
          <b>Features:</b>
        <br/></p>
        <ul>
          <li>Visualization, control and management of lighting and electrical appliances (on - off)</li>
          <li>User-friendly, easy-to-use interface</li>
          <li>Works with Google Assistant and Amazon Alexa</li>
          <li>Secure connection to Wi-Fi</li>
          <li>No hub/gateway is required</li>
          <li>Leading - Trailing Edge and Soft Start functions</li>
          <li>Setting of brightness lower limit</li>
          <li>Time-schedules</li>
          <li>Maximum economy and comfort through smart scenes</li>
          <li>Low implementation cost in existing or new installations</li>
          <li>Remote control via Wi-Fi and Internet with the “MASTER Smart Home” app for smartphone, tablet and PC and local control via button</li>
        </ul>

        <div className="technical-specs">
          <h3>Technical Specifications</h3>
          <p><b>LED CONTROLLER : </b> 1 CHANNEL (Digital)</p>
          <p><b>OPERATING VOLTAGE:</b> 12 - 24 V DC</p>
          <p><b>OUTPUT POWER:</b>  250W/12V & 500W/24V</p>
          <p><b>OUTPUT POWER BOOST: </b> The output power of the product can be expanded indefinitely by adding the amplifiers LD-250W-BST with output power 250W/12VDC and 500W/24VDC each.</p>
          <p><b>STAND BY CONSUMPTION: </b>≤ 1W</p>
          <p><b>Function : </b>Soft - Start </p>
          <p><b>MODE OF OPERATION :</b> Leading Edge - Trailing Edge (with the MASTER Smart Home app)</p>
          <p><b>Fuse : </b>Electronic (overheating and overvoltage protection with automatic reset to operation)</p>
          <p><b>Lower limit setting : </b>SD-1CHL enables the user to preset the minimum brightness of the dimmable LED lamps if required. This process is achieved through the MASTER Smart Home application. </p>
          <br/>
          <p>Control :</p>
            <ul>
              <li>LED Lamps (Dimmable)</li>
              <li>LED Strips</li>
              <li>Halogen Lamps</li>
            </ul>
          <br/>
          <p><b>CONTROL :</b></p>
          <ul>
            <li>Button: With one or more parallel buttons - (ON/OFF) with instant push</li>
            <li>1-10V Protocol: From digital systems and dimmers with 1-10V protocol</li>
            <li>Remote: With the MASTER Smart Home app for smartphones or tablets over Wi-Fi or Data</li>
          </ul><br/>
          <p><b>ENVIRONMENT TEMPERATURE:</b> -20°C until +50°C</p>
          <p><b>WIRE SIZE:</b> From Ø0.5 mm to Ø3.5 mm</p>
          <p>
            <b>Mounting :</b> Din-rail mounting 35x7.5mm (DIN 45277)
          </p>
        </div>
      </>
    ),
  },
  "sd-rgb": {
    name: "SMART LED CONTROLLER 12-24 VDC / 3x8A (Wi-Fi)",
    image: SW9,
    description: (
      <>
        <p>The 
          <b> LED Controller SD-RGB</b> (3 channel) is a cutting-edge product of the MASTER Smart Home line, suitable for managing and controlling lighting intensity and color using LED RGB Strips (12-24V DC). The output power of the product can be expanded indefinitely by adding amplifiers thereby making any electrical application possible.
        </p>
        <p>Adjusting the intensity and color of your hidden lighting locally with a push-button, 1-10V protocol and remotely via the “MASTER Smart Home” app give the perfect result. The following user manual will help you install the “MASTER Smart Home” app for Android or iOS and enjoy the “smart” lighting control functions.</p>
        <p><br/>
          <b>Features:</b>
        <br/></p>
        <ul>
          <li>Visualization, control and management of lighting and electrical appliances (on - off)</li>
          <li>User-friendly, easy-to-use interface</li>
          <li>Works with Google Assistant and Amazon Alexa</li>
          <li>Secure connection to Wi-Fi</li>
          <li>No hub/gateway is required</li>
          <li>Leading - Trailing Edge and Soft Start functions</li>
          <li>Setting of brightness lower limit</li>
          <li>Time-schedules</li>
          <li>Maximum economy and comfort through smart scenes</li>
          <li>Low implementation cost in existing or new installations</li>
          <li>Remote control via Wi-Fi and Internet with the “MASTER Smart Home” app for smartphone, tablet and PC and local control via button</li>
        </ul>

        <div className="technical-specs">
          <h3>Technical Specifications</h3>
          <p><b>LED CONTROLLER : </b> 3 CHANNEL (Digital)</p>
          <p><b>OPERATING VOLTAGE:</b> 12 - 24 V DC</p>
          <p><b>OUTPUT POWER:</b>  96W/12V & 192W/24V</p>
          <p><b>OUTPUT POWER BOOST: </b> The output power of the product can be expanded indefinitely by adding the amplifiers LD-RGB-BST with output power 96W/12VDC & 192W/24V each.</p>
          <p><b>STAND BY CONSUMPTION: </b>≤ 1W</p>
          <p><b>Function : </b>Soft - Start </p>
          <p><b>MODE OF OPERATION :</b> Leading Edge - Trailing Edge (with the MASTER Smart Home app)</p>
          <p><b>Fuse : </b>Electronic (overheating and overvoltage protection with automatic reset to operation)</p>
          <p><b>Lower limit setting : </b>SD-1CHL enables the user to preset the minimum brightness of the dimmable LED lamps if required. This process is achieved through the MASTER Smart Home application. </p>
          <br/>
          <p>Control :</p>
            <ul>
              <li>LED Projectors (RGB)</li>
              <li>LED Strips (RGB)</li>
            </ul>
          <br/>
          <p><b>CONTROL :</b></p>
          <ul>
            <li>Button: With one or more parallel buttons - (ON/OFF) with instant push</li>
            <li>1-10V Protocol: From digital systems and dimmers with 1-10V protocol</li>
            <li>Remote: With the MASTER Smart Home app for smartphones or tablets over Wi-Fi or Data</li>
          </ul><br/>
          <p><b>ENVIRONMENT TEMPERATURE:</b> -20°C until +50°C</p>
          <p><b>WIRE SIZE:</b> From Ø0.5 mm to Ø3.5 mm</p>
          <p>
            <b>Mounting :</b> Din-rail mounting 35x7.5mm (DIN 45277)
          </p>
        </div>
      </>
    ),
  },
  "sd-lcd": {
    name: "7-INCH TOUCHSCREEN CONTROLLER (Wi-Fi)",
    image: SW10,
    description: (
      <>
        <p>The 
          <b> Touchscreen Controller SD-LCD</b> offers an easy way to operate and manage electrical appliances connected to the local network, in residential and small or larger business installations.   
        </p>
        <p>All functions are organized and grouped according to the needs of each user, allowing the “Smart Home” to think and act on its own.</p>
        <p>The stylish design of the controller fits all the decor styles of modern homes as it gives plenty of choices from a range of color shades. It provides two options for mounting (wall or surface) depending on the surrounding decoration.</p>
        <p>The fact that no operating system is installed, combined with the option for a wired connection with ethernet cable, makes it reliable even in the most adverse operating environments, which enables the user to have complete control over the system without interruptions and unwanted interference.</p>
        <div className="technical-specs">
          <h3>Technical Specifications</h3>
          <p><b>OPERATING VOLTAGE:</b> 180 - 230 V AC</p>
          <p><b>OUTPUT FREQUENCY:</b>  50Hz</p>
          <p><b>CONNECTION : </b> Wi-Fi @ 2.4GHz or Ethernet Cable (RJ45)</p>
          <p><b>SCREEN SIZE:</b> 7.0 INCHES</p>
          <p><b>SCREEN RESOLUTION:</b> 800x480 pixels</p>        
        </div>  
      </>  
  ),
},
"sb-roll": {
    name: "ROLLING SHUTTER AND SHADING SYSTEMS CONTROLLER 230 VAC / 5A",
    image: SW11,
    description: (
      <>
        <p>The 
          <b> Electric Shutter and Shading Systems Controller SB-ROLL</b> (smart motor controller) ensures complete management of electric shutters and shading systems individually or in groups.
        </p>
        <p>Its placement in the junction box replaces the previous dual key technology (UP / DOWN), with on or more parallel connected buttons of each type and company. It provides complete control over your electric shutters and awnings. Control remotely wherever you are using your smartphone, tablet or PC with the MASTER Smart Home app. Comfort, security and energy saving in the modern home. The following user manual will help you install the “MASTER Smart Home” app for Android or iOS and enjoy the “smart” shutter control functions.</p>
        <p><br/>
          <b>Features:</b>
        <br/></p>
        <ul>
          <li>Visualization, control and management of lighting and electrical appliances (on - off)</li>
          <li>User-friendly, easy-to-use interface</li>
          <li>Works with Google Assistant and Amazon Alexa</li>
          <li>Secure connection to Wi-Fi</li>
          <li>No hub/gateway is required</li>
          <li>Leading - Trailing Edge and Soft Start functions</li>
          <li>Setting of brightness lower limit</li>
          <li>Time-schedules</li>
          <li>Maximum economy and comfort through smart scenes</li>
          <li>Low implementation cost in existing or new installations</li>
          <li>Remote control via Wi-Fi and Internet with the “MASTER Smart Home” app for smartphone, tablet and PC and local control via button</li>
        </ul>

        <div className="technical-specs">
          <h3>Technical Specifications</h3>
          <p><b>SHUTTER CONTROLLER : </b> MOTOR CONTROLLER AC</p>
          <p><b>OPERATING VOLTAGE:</b> 180-230V AC</p>
          <p><b>OUTPUT POWER:</b>  1150W / 5A max</p>
          <p><b>OUTPUT FREQUENCY: </b> 50Hz</p>
          <p><b>STAND BY CONSUMPTION: </b>≤ 1W</p>
          <br/>
          <p><b>CONTROL :</b></p>
          <ul>
            <li>Button: With one or more parallel buttons - (ON/OFF) with instant push</li>
            <li>Remote: With the MASTER Smart Home app for smartphones or tablets over Wi-Fi or Data</li>
          </ul><br/>
          <p><b>ENVIRONMENT TEMPERATURE:</b> -20°C until +50°C</p>
          <p><b>WIRE SIZE:</b> From Ø0.5 mm to Ø3.5 mm</p>
          <p>
            <b>Mounting :</b> Electrical switch box min. 40mm
          </p>
        </div>
      </>
    ),
  },
  "sd-lcd": {
    name: "7-INCH TOUCHSCREEN CONTROLLER (Wi-Fi)",
    image: SW10,
    description: (
      <>
        <p>The 
          <b> Touchscreen Controller SD-LCD</b> offers an easy way to operate and manage electrical appliances connected to the local network, in residential and small or larger business installations.   
        </p>
        <p>All functions are organized and grouped according to the needs of each user, allowing the “Smart Home” to think and act on its own.</p>
        <p>The stylish design of the controller fits all the decor styles of modern homes as it gives plenty of choices from a range of color shades. It provides two options for mounting (wall or surface) depending on the surrounding decoration.</p>
        <p>The fact that no operating system is installed, combined with the option for a wired connection with ethernet cable, makes it reliable even in the most adverse operating environments, which enables the user to have complete control over the system without interruptions and unwanted interference.</p>
        <div className="technical-specs">
          <h3>Technical Specifications</h3>
          <p><b>OPERATING VOLTAGE:</b> 180 - 230 V AC</p>
          <p><b>OUTPUT FREQUENCY:</b>  50Hz</p>
          <p><b>CONNECTION : </b> Wi-Fi @ 2.4GHz or Ethernet Cable (RJ45)</p>
          <p><b>SCREEN SIZE:</b> 7.0 INCHES</p>
          <p><b>SCREEN RESOLUTION:</b> 800x480 pixels</p>        
        </div>  
      </>  
  ),
},
"sw-1chl": {
    name: "RAIL-MOUNTED SMART SWITCH 1 CHANNEL 230 VAC / 8A (Wi-Fi)",
    image: SW1,
    description: (
      <>
        <p>The 
          <b> Rail-mounted switch SW-1CHL</b> (smart switch / 1 channel) is a cutting-edge product of the MASTER Smart Home line, suitable for controlling and managing (on-off) your lighting and electrical  appliances.
        </p>
        <p>Automate, control and inspect the state of your electrical appliances while reducing your household costs, with the ability to operate locally via buttons and online via internet or Wi-Fi using smartphone, tablet or PC. The following user manual will help you install the MASTER Smart Home app for Android or iOS and enjoy the “smart” lighting control functions.</p>
        <p><br/>
          <b>Features:</b>
        <br/></p>
        <ul>
          <li>Visualization, control and management of lighting and electrical appliances (on - off)</li>
          <li>User-friendly, easy-to-use interface</li>
          <li>Works with Google Assistant and Amazon Alexa</li>
          <li>Secure connection to Wi-Fi</li>
          <li>No hub/gateway is required</li>
          <li>Timer function</li>
          <li>Time-schedules</li>
          <li>Maximum economy and comfort through smart scenes</li>
          <li>Low implementation cost in existing or new installations</li>
          <li>Remote control via Wi-Fi and Internet with the “MASTER Smart Home” app for smartphone, tablet and PC and local control via button</li>
        </ul>

        <div className="technical-specs">
          <h3>Technical Specifications</h3>
          <p><b>RAIL-MOUNTED SWITCH (1 MODULE):</b> 1 Channel (Relay)</p>
          <p><b>OPERATING VOLTAGE:</b> 180-230V AC</p>
          <p><b>OUTPUT POWER:</b> 1840W / 8A max</p>
          <p><b>OUTPUT POWER BOOST: </b>The output power of the product can be extended by adding the corresponding power relay according to the electric load</p>
          <p><b>STAND BY CONSUMPTION: </b>≤ 1W</p>
          <br/>
          <p><b>CONTROL :</b></p>
          <ul>
            <li>Local: ON/OFF from the device</li>
            <li>Button: With one or more parallel buttons - (ON/OFF) with instant push</li>
            <li>Remote: With the MASTER Smart Home app for smartphones or tablets over Wi-Fi or Data</li>
          </ul><br/>
          <p><b>ENVIRONMENT TEMPERATURE:</b> -20°C until +50°C</p>
          <p><b>WIRE SIZE:</b> From Ø0.5 mm to Ø3.5 mm</p>
          <p>
            <b>Mounting :</b> Din-rail mounting 35x7.5mm (DIN 45277)
          </p>
        </div>
      </>
    ),
  },
  "sw-6chl": {
    name: "RAIL-MOUNTED SMART SWITCH 6 CHANNEL 230 VAC / 6*10A (Wi-Fi)",
    image: SW2,
    description: (
      <>
        <p>The 
          <b> Rail-mounted switch SW-6CHL</b> (smart switch / 6 channel) is a cutting-edge product of the MASTER Smart Home line, suitable for controlling and managing (on-off) your lighting and electrical appliances. Installation of the SW-6CHL on the electrical panel enables ON/OFF capabilities in 6 different sections of an electrical installation. Its high-definition liquid crystal display, the local and remote control of lighting or electrical appliances combined with data visualization make it unique.
        </p>
        <p>Automate, manage and control the state of your lighting and appliances in your home and business environment, operating locally via buttons and remotely over internet or Wi-Fi using smartphone, tablet or PC with the MASTER Smart Home application. The following user manual will help you install the “MASTER Smart Home” app for Android or iOS and enjoy the “smart” lighting control functions.</p>
        <p><br/>
          <b>Features:</b>
        <br/></p>
        <ul>
          <li>Visualization, control and management of lighting and electrical appliances (on - off)</li>
          <li>User-friendly, easy-to-use interface</li>
          <li>Works with Google Assistant and Amazon Alexa</li>
          <li>Secure connection to Wi-Fi</li>
          <li>No hub/gateway is required</li>
          <li>Timer function</li>
          <li>Time-schedules</li>
          <li>Maximum economy and comfort through smart scenes</li>
          <li>Low implementation cost in existing or new installations</li>
          <li>Remote control via Wi-Fi and Internet with the “MASTER Smart Home” app for smartphone, tablet and PC and local control via button</li>
        </ul>

        <div className="technical-specs">
          <h3>Technical Specifications</h3>
          <p><b>RAIL-MOUNTED SWITCH (6 MODULE):</b> 6 Channel (Relay)</p>
          <p><b>OPERATING VOLTAGE:</b> 180-230V AC</p>
          <p><b>OPERATING FREQUENCY :</b> 50Hz</p>
          <p><b>OUTPUT POWER:</b> 2300W / 10A max</p>
          <p><b>OUTPUT POWER BOOST: </b>The output power of the product can be extended by adding the corresponding power relay according to the electric load</p>
          <p><b>STAND BY CONSUMPTION: </b>≤ 1W</p>
          <br/>
          <p><b>CONTROL :</b></p>
          <ul>
            <li>Local: ON/OFF from the device</li>
            <li>Button: With one or more parallel buttons - (ON/OFF) with instant push</li>
            <li>Remote: With the MASTER Smart Home app for smartphones or tablets over Wi-Fi or Data</li>
          </ul><br/>
          <p><b>ENVIRONMENT TEMPERATURE:</b> -20°C until +50°C</p>
          <p><b>WIRE SIZE:</b> From Ø0.5 mm to Ø3.5 mm</p>
          <p>
            <b>Mounting :</b> Din-rail mounting 35x7.5mm (DIN 45277)
          </p>
        </div>
      </>
    ),
  },
  "sw-400b": {
    name: "FLUSH-MOUNTED SMART SWITCH 230 VAC / 400W (Wi-Fi)",
    image: SW4,
    description: (
      <>
        <p>The 
          <b> Flush-mounted switch SW-400B</b> (1 channel) is a cutting-edge product of the MASTER Smart Home line, suitable for controlling and managing (on-off) your lighting and electrical appliances.
        </p>
        <p>Its placement in the junction box and its control locally by one or more parallel buttons of any type or company, make the SW-400B dimmer unique. Automate, control and inspect the state of your electrical appliances. The following user manual will help you install the “MASTER Smart Home” app for Android or iOS and enjoy the “smart” lighting control functions.</p>
        <p><br/>
          <b>Features:</b>
        <br/></p>
        <ul>
          <li>Visualization, control and management of lighting and electrical appliances (on - off)</li>
          <li>User-friendly, easy-to-use interface</li>
          <li>Works with Google Assistant and Amazon Alexa</li>
          <li>Secure connection to Wi-Fi</li>
          <li>No hub/gateway is required</li>
          <li>Timer function</li>
          <li>Time-schedules</li>
          <li>Maximum economy and comfort through smart scenes</li>
          <li>Low implementation cost in existing or new installations</li>
          <li>Remote control via Wi-Fi and Internet with the “MASTER Smart Home” app for smartphone, tablet and PC and local control via button</li>
        </ul>

        <div className="technical-specs">
          <h3>Technical Specifications</h3>
          <p><b>FLUSH-MOUNTED SWITCH : </b> 1 Channel (Electronic)</p>
          <p><b>OPERATING VOLTAGE:</b> 180-230V AC</p>
          <p><b>OPERATING FREQUENCY :</b> 50Hz</p>
          <p><b>OUTPUT POWER:</b> 400W</p>
          <p><b>OUTPUT POWER BOOST: </b>The output power of the product can be extended by adding the corresponding power relay according to the electric load</p>
          <p><b>STAND BY CONSUMPTION: </b>≤ 1W</p>
          <br/>
          <p><b>CONTROL :</b></p>
          <ul>
            <li>Button: With one or more parallel buttons - (ON/OFF) with instant push</li>
            <li>Remote: With the MASTER Smart Home app for smartphones or tablets over Wi-Fi or Data</li>
          </ul><br/>
          <p><b>ENVIRONMENT TEMPERATURE:</b> -20°C until +50°C</p>
          <p><b>WIRE SIZE:</b> From Ø0.5 mm to Ø3.5 mm</p>
          <p>
            <b>Mounting :</b> Din-rail mounting 35x7.5mm (DIN 45277)
          </p>
        </div>
      </>
    ),
  },
  "sw-ir40": {
    name: "SMART SOCKET AND IR CONTROLLER 230 VAC/16A",
    image: SW12,
    description: (
      <>
        <p>The 
          <b> SW-IR40 Smart Socket</b> can turn on and off a multitude of devices and systems with one touch on the mobile using the MASTER Smart Home app for smartphone, tablet and PC. The built-in infrared transmitter offers the ability to remotely control the AC from smartphone, making it unique. The following user manual will help you install the “MASTER Smart Home” app for Android or iOS and enjoy the “smart” appliance and AC control functions.</p>
        <p><br/>
          <b>Features:</b>
        <br/></p>
        <ul>
          <li>Visualization, control and management of lighting and electrical appliances (on - off)</li>
          <li>User-friendly, easy-to-use interface</li>
          <li>Works with Google Assistant and Amazon Alexa</li>
          <li>Secure connection to Wi-Fi</li>
          <li>No hub/gateway is required</li>
          <li>Timer function</li>
          <li>Time-schedules</li>
          <li>Maximum economy and comfort through smart scenes</li>
          <li>Low implementation cost in existing or new installations</li>
          <li>Remote control via Wi-Fi and Internet with the “MASTER Smart Home” app for smartphone, tablet and PC and local control via button</li>
        </ul>

        <div className="technical-specs">
          <h3>Technical Specifications</h3>
          <p><b>SMART SOCKET : </b> Relay</p>
          <p><b>OPERATING VOLTAGE:</b> 180-230V DC</p>
          <p><b>OPERATING FREQUENCY :</b> 50Hz</p>
          <p><b>OUTPUT POWER:</b>  3680W / 16A max</p>
          <p><b>STAND BY CONSUMPTION: </b>≤ 1W</p>
          <br/>
          <p><b>CONTROL :</b></p>
          <ul>
            <li>Button: With one or more parallel buttons - (ON/OFF) with instant push</li>
            <li>Remote: With the MASTER Smart Home app for smartphones or tablets over Wi-Fi or Data</li>
          </ul><br/>
          <p><b>ENVIRONMENT TEMPERATURE:</b> -20°C until +50°C</p>
          <p>
            <b>Mounting :</b> Din-rail mounting 35x7.5mm (DIN 45277)
          </p>
        </div>
      </>
    ),
  },
  "sd-lcd": {
    name: "7-INCH TOUCHSCREEN CONTROLLER (Wi-Fi)",
    image: SW10,
    description: (
      <>
        <p>The 
          <b> Touchscreen Controller SD-LCD</b> offers an easy way to operate and manage electrical appliances connected to the local network, in residential and small or larger business installations.   
        </p>
        <p>All functions are organized and grouped according to the needs of each user, allowing the “Smart Home” to think and act on its own.</p>
        <p>The stylish design of the controller fits all the decor styles of modern homes as it gives plenty of choices from a range of color shades. It provides two options for mounting (wall or surface) depending on the surrounding decoration.</p>
        <p>The fact that no operating system is installed, combined with the option for a wired connection with ethernet cable, makes it reliable even in the most adverse operating environments, which enables the user to have complete control over the system without interruptions and unwanted interference.</p>
        <div className="technical-specs">
          <h3>Technical Specifications</h3>
          <p><b>OPERATING VOLTAGE:</b> 180 - 230 V AC</p>
          <p><b>OUTPUT FREQUENCY:</b>  50Hz</p>
          <p><b>CONNECTION : </b> Wi-Fi @ 2.4GHz or Ethernet Cable (RJ45)</p>
          <p><b>SCREEN SIZE:</b> 7.0 INCHES</p>
          <p><b>SCREEN RESOLUTION:</b> 800x480 pixels</p>        
        </div>  
      </>  
  ),
},
"st-520r": {
    name: "SMART THERMOSTAT (Wi-Fi)",
    image: SW13,
    description: (
      <>
        <p>The 
          <b> ST-520/R Thermostat</b> from the “MASTER Smart Home” series is a comprehensive solution for controlling and managing heating and cooling systems, suitable for both residential and commercial spaces, with the ability to manage fan-coils. Its modern and elegant design, combined with carefully selected colors, perfectly matches any style of decor, whether in homes or professional settings.
        </p>
        <p>The thermostat offers a wide range of features that fully adapt to the user's needs, ensuring optimal performance and maximum energy savings. At the same time, it provides ease and flexibility in climate control, making it the ideal choice for any modern environment.</p>
        <p><br/>
          <b>Features:</b>
        <br/></p>
        <ul>
          <li>4" Color Touchscreen: User-friendly interface available in Greek and English, allowing easy navigation and quick access to settings.</li>
          <li>Voice Control: Compatible with Google Assistant and Amazon Alexa, enabling temperature control via voice commands for added convenience and ease.</li>
          <li>Wi-Fi Connection Without Central Hub: Simplified installation without unnecessary components, offering flexibility and reduced application cost.</li>
          <li>Secure Connection: Supports WEP/WPA/WPA2 and IPv4 security protocols, ensuring network and data security.</li>
          <li>Automatic Firmware Upgrade: The device automatically updates with the latest improvements and features for optimal performance.</li>
          <li>Accurate Temperature and Humidity Measurement: Built-in sensors provide precise measurement and maintenance of temperature and humidity in your space. There is also the option to measure from a different reference point via a wireless receiver.</li>
          <li>Smart Operating Modes: The thermostat includes pre-set programs such as Economy, Away, Comfort, and Night, which can be customized to your needs for maximum economy and comfort.</li>
          <li>Weekly Scheduling: Ability to program the thermostat's functions for each day of the week, with personalized temperature settings to optimize consumption.</li>
          <li>TPI Self-Learning Algorithm: The TPI (Time Proportional & Integral) algorithm optimizes heating/cooling performance, adapting system operation to your needs for better energy efficiency.</li>
          <li>Frost Protection: The thermostat has a frost protection feature, ensuring safe operation of the system even at low temperatures.</li>
          <li>Master/Slave Function: Allows multiple thermostat installations with central control, enabling centralized management of multiple units from a single thermostat.</li>
          <li>Wireless Control of Heating/Cooling Systems: Fully supports wireless control of any heating and cooling system, as well as 2/4-pipe fan-coils (3 speeds, Auto, ON/OFF, 0-10V) via a smart actuator.</li>
          <li>Three-Level Locking: Offers a three-level locking option (touch, user settings & advanced settings), protecting settings from accidental changes or unauthorized access.</li>
          <li>Multi-Functional Screen with Integrated Software: Provides control over all connected devices in the “MASTER Smart Home” system on the wireless local Wi-Fi network.</li>
        </ul><br/>
        <div className="technical-specs">
          <h3>Technical Specifications</h3>
          <p><b>OPERATING VOLTAGE:</b> 180 - 230 V AC</p>
          <p><b>OUTPUT FREQUENCY:</b>  50Hz</p>
          <p><b>MAXIMUM LOAD : </b>5(2) A</p>
          <p><b>OPERATION : </b>4" color touchscreen</p>
          <p><b>FUNCTION : </b>Heating / Cooling or DHW (Domestic Hot Water)</p>
          <p><b>SYSTEM COMPATIBILITY : </b>Gas boilers, heat pumps, oil boilers, biofuel boilers, air conditioners, electric radiators, Fan-coil</p>
          <p><b>TEMPERATURE SENSOR TYPE : </b>High precision digital sensor (±0,5°C)</p>
          <p><b>OPERATING TEMPERATURE	 : </b>5°C – 40°C</p>
          <p><b>TEMPERATURE SETTING RANGE	 : </b>Heating: 8°C to 32°C, Cooling: 16°C to 40°C</p>
          <p><b>STORAGE TEMPERATURE : </b>-20°C to +50°C</p>
          <p><b>Wi-Fi FREQUENCY / POWER : </b>2414-2472MHz / 20dBm (max)</p>
          <p><b>SECURITY PROTOCOL : </b>WEP/WPA/WPA2, Protocol IPv4</p>
          <p><b>STANDBY POWER CONSUMPTION : </b>≤ 1W</p>
          <p><b>WIRE TERMINALS : </b>Ø1mm to Ø2,5mm</p>
          <p><b>DIMENSIONS : </b>91x91x24 mm</p>
          <p><b>MOUNTING TYPE : </b>Wall Mounting</p>  
        </div>  
      </>  
  ),
},
"st-520rv": {
    name: "SMART RECEIVER",
    image: SW14,
    description: (
      <>
        <p>The 
          <b> ST-520-RV SMART RECEIVER</b> is a wireless two-zone actuator designed for managing heating and cooling systems, or heating and Domestic Hot Water (DHW), in combination with the ST-520/R Smart Thermostat. It functions as a wireless receiver, receiving commands from the ST-520/R thermostat and activating the connected systems via two independent relays.
        </p>
        <p>Its flexibility allows it to adapt to various installations, as it can be used either for heating and cooling control or for heating and DHW, providing comprehensive control and automation.The ST-520-RV is a reliable and versatile solution for installations that require intelligent thermal load management, offering energy efficiency and full automation through the ST-520/R thermostat.</p>
        <p><br/>
          <b>Features:</b>
        <br/></p>
        <ul>
          <li>Long-range wireless communication for a stable connection with the ST-520/R thermostat.</li>
          <li>Reliable operation in multi-zone systems, ideal for installations with multiple zones.</li>
          <li>Support for multiple thermostats in a shared setup (Master/Slave mode).</li>
          <li>Remote management of HVAC systems via the ST-520/R for maximum convenience.</li>
          <li>Wireless Thermostat Receiver: Acts as an intermediary between the ST-520/R and the heating/cooling system, receiving and executing the thermostat’s commands.</li>
          <li>Two-Zone Management: Equipped with two independent relays, allowing it to be used for either heating and cooling, or for heating and DHW (Domestic Hot Water) in installations without cooling.</li>
          <li>Repeater Function: The ST-520-RV can also operate as a signal repeater, enabling the connection of thermostats located out of range to extend the wireless communication coverage.</li>
        </ul><br/>
        <div className="technical-specs">
          <h3>Technical Specifications</h3>
          <p><b>OPERATING VOLTAGE:</b> 230Vac 50/60Hz</p>
          <p><b>TWO INDEPENDENT RELAYS : </b>  Relay 1 [Q12 - Q14]NO / Relay 2 [Q21 - Q24]NO</p>
          <p><b>MAXIMUM RELAY CONTACT LOAD : </b>8(2) A</p>
          <p><b>COMMUNICATION RANGE : </b>Up to 100m in open space</p>
          <p><b>COMMUNICATION FREQUENCY : </b>2.4GHz (ESP-NOW)</p>
          <p><b>INPUT 1 AND INPUT 2 (SELV) : </b>Input 1 [I16 - I17]NC / Input 2 [I26 - I27]NO</p>
          <p><b>OPERATING TEMPERATURE	RANGE : </b>-10°C – 50°C</p>
          <p><b>PROTECTION RATING	 : </b>IP20</p>
          <p><b>MOUNTING : </b>Wall-mounted</p>
          </div>
      </>  
  ),
},
"st-520fc": {
    name: "SMART FAN COIL CONTROLLER",
    image: SW15,
    description: (
      <>
        <p>The 
          <b> ST-520-FC SMART FAN COIL CONTROLLER </b> is a wireless controller specifically designed for managing Fan Coil units in heating and cooling applications. It provides three-speed operation control, ensuring precise adjustment of temperature and comfort in the room.
        </p>
        <p>It operates in combination with the Smart Thermostat ST-520/R, from which it wirelessly receives commands, enabling full automation of the fan coil without complex wiring. Its flexibility makes it ideal for both residential and commercial installations, offering efficient energy use and comfort throughout the year.The ST-520FC combines reliability, ease of installation, and advanced wireless control, making it a complete solution for modern heating and cooling systems with fan coils.</p>
        <p><br/>
          <b>Features:</b>
        <br/></p>
        <ul>
          <li>Long-range wireless communication for a stable connection with the ST-520/R thermostat.</li>
          <li>Reliable operation in multi-zone systems, ideal for installations with multiple zones.</li>
          <li>Support for multiple thermostats in a shared setup (Master/Slave mode).</li>
          <li>Remote management of HVAC systems via the ST-520/R for maximum convenience.</li>
          <li>Wireless Thermostat Receiver: Acts as an intermediary between the ST-520/R and the heating/cooling system, receiving and executing the thermostat’s commands.</li>
          <li>Repeater Function: The ST-520-RV can also operate as a signal repeater, enabling the connection of thermostats located out of range to extend the wireless communication coverage.</li>
        </ul><br/>
        <div className="technical-specs">
          <h3>Technical Specifications</h3>
          <p><b>OPERATING VOLTAGE:</b> 230Vac 50/60Hz</p>
          <p><b>TWO INDEPENDENT RELAYS : </b>  Relay 1 [Q12 - Q14]NO / Relay 2 [Q21 - Q24]NO</p>
          <p><b>THREE FAN SPEED SELECTION RELAYS : </b>Relay 1 [S1]NO / Relay 2 [S2]NO / Relay 3 [S3]NO</p>
          <p><b>MAXIMUM RELAY CONTACT LOAD : </b>8(2) A</p>
          <p><b>COMMUNICATION RANGE : </b>Up to 100m in open space</p>
          <p><b>COMMUNICATION FREQUENCY : </b>2.4GHz (ESP-NOW)</p>
          <p><b>INPUT (SELV) : </b>Input 1 [I16 - I17] (SELV)</p>
          <p><b>OPERATING TEMPERATURE	RANGE : </b>-10°C – 50°C</p>
          <p><b>PROTECTION RATING	 : </b>IP20</p>
          <p><b>MOUNTING : </b>Wall-mounted</p>
          </div>
      </>  
  ),
},
"mobile": {
    name: "MASTER SMART HOME APP",
    image: Sw16,
    description: (
      <>
        <p>Take control of your everyday life and make it simple. Control LED lightning, electrical blinds, air condition and even schuko plugs form wherever you are.
Set up easily scenes for your home or business and making all your appliances smart using your Smartphone, tablet or PC and with the application MASTER Smart Home.
        </p>
        <p>Automate different scenes of lighting intensity, creating a comfort environment according to your needs quick and easy. Activate or deactivate multiple devices with just one touch such as heaters, watering systems, coffee machine etc.</p>
        <p>Adjust your heating and your cooling from wherever you are and not just on/off but to the desirable temperature.

The deactivation of all the appliances, heating and cooling, the lightning, the blinds and shutters with one touch on your Smartphone or Tablet is easy and fast. This simple group command creates a ‘’smart’’ and fully functional residence that can think on it’s own.</p>
<p><b>The application MASTER Smart Home is constantly developing and it will always be available to every Smartphone or Tablet. Download it from Google Play and App Store.</b></p>  
      </>
  ),
},
"browser": {
    name: "ONLINE MANAGEMENT APPLICATION",
    image: SW17,
    description: (
      <>
        <p>Simple and easy to use, MASTER’s Online Management Application is another way to control your appliances, LED lightning and blinds from wherever you are.
        </p>
        <p>Manage your lighting scenes. Activate or deactivate devices or even hole groups, set the proper temperature for the heating or cooling and close or open the blinds and shutters according to your needs. All these commands can be done from your personal computer.</p>
        <p>Adjust your heating and your cooling from wherever you are and not just on/off but to the desirable temperature.The deactivation of all the appliances, heating and cooling, the lightning, the blinds and shutters with one touch on your Smartphone or Tablet is easy and fast. This simple group command creates a ‘’smart’’ and fully functional residence that can think on it’s own.</p>
<p>It’s not mandatory to install a specific program because the MASTER’s Online Management Application is compatible with every browser (Chrome, FireFox, Safari, Edge, Opera). Connect to your account through your personal computer, Android phone, iPhone, Tablet etc.</p>  
      </>
  ),
},      
  "ld-250w": {
    name: "LD-250W",
    image: LD1,
    description: (
      <>
        <p>
          <b>Led Controller LD-250W</b> was designed to fulfill the needs of
          illumination control and management of lighting fixtures using LED
          technology at <b>12VDC</b> and <b>24VDC</b> like Led Stripes, Led bulbs, etc. It is
          a safe and reliable product because it was designed with special
          integrated circuits and plastic parts for adverse operating
          conditions.
        </p>

        <p><br/>
          <b>Led Controller LD-250W operation features:</b>
        <br/></p>
        <ul>
          <li>
            Control from one or more parallel connected button to adjust
            lighting intensity (ON / OFF by briefly pressing the button and
            stretch the lighting - Dimming with a long press).
          </li>
          <li>
            Control through other systems and lighting regulators having
            communication protocol 1-10V.
          </li>
          <li>
            <b>Input:</b> 12 - 24V DC power supply
          </li>
          <li>
            <b>Output:</b> 12 - 24V DC / 21A to the electrical load.
          </li>
          <li>Function 12V / 250W operation 24V / 500W</li>
        </ul>

        <div className="technical-specs">
          <h3>Technical Specifications</h3>
          <p>FUNCTION: Soft - Start</p>
          <p>OPERATING VOLTAGE: 12-24V DC</p>
          <p>OUTPUT POWER: 250 Watt /12V & 500Watt /24V</p><br/>
          <p><b>CONTROL LOAD:</b></p>
          <ul>
            <li>LED lamps (dimmable)</li>
            <li>LED stripes</li>
            <li>Halogen lamps</li>
            <li>Resistive</li>
          </ul><br/>
          <p><b>ENVIRONMENT TEMPERATURE:</b> -20°C until +50°C</p>
          <p>
            <b>FUSE:</b> Electronic fuse for short-circuit protection with automatic
            reset
          </p>
          <p><b>WIRE SIZE:</b> From Ø0.5 mm to Ø3.5 mm</p>
          <p>
            <b>EUROPEAN COMMUNITY DIRECTIVES:</b> The product complies with directives
            (LVD) 2014/35/EU and (EMC) 2014/30/EU
          </p>
        </div>
      </>
    ),
  },

  // ------- Example other products (you can keep yours as is) -------
  "ld-250w-rf": {
    name: "LD-250W-RF",
    image: LD2,
    description:(
      <>
      <p>
        <b>Led Controller LD-250W-RF</b> was designed to fulfill the needs of illumination control and management of lighting fixtures using LED technology at 12VDC and 24VDC like Led Stripes, Led bulbs, etc. It is a safe and reliable product because it was designed with special integrated circuits and plastic parts for adverse operating conditions.
      </p><br/>
      <p>
        <b>Led Controller LD-250W-RF</b> operation features:
      </p>
      <ul>
        <li>Wired operation with one or more parallel buttons for adjusting the lighting intensity (ON / OFF by briefly pressing the button and stretch the lighting - Dimming with a long press).</li>
        <li>Wireless operation with a wirelessthree buttons remote control (RF-CTRL). (ON / OFF button with momentary pressure and UP / DOWN buttons to increase or decrease -Dimming of light respectively).</li>
        <li><b>Input:</b> 12 - 24V DC power supply.</li>
        <li><b>Output:</b> 12 - 24V DC / 21A to the electrical load.</li>
        <li>Function 12V / 250W   Operation 24V / 500W</li>
      </ul><br/>
      <div className="technical-specs">
          <h3>Technical Specifications</h3>
          <p>FUNCTION: Soft - Start</p>
          <p>OPERATING VOLTAGE: 12-24V DC</p>
          <p>OUTPUT POWER: 250 Watt /12V & 500Watt /24V</p><br/>
          <p><b>CONTROL LOAD:</b></p>
          <ul>
            <li>LED lamps (dimmable)</li>
            <li>LED stripes</li>
            <li>Halogen lamps</li>
            <li>Resistive</li>
          </ul><br/>
          <p><b>ENVIRONMENT TEMPERATURE:</b> -20°C until +50°C</p>
          <p>
            <b>FUSE:</b> Electronic fuse for short-circuit protection with automatic
            reset
          </p>
          <p><b>WIRE SIZE:</b> From Ø0.5 mm to Ø3.5 mm</p>
          <p>
            <b>EUROPEAN COMMUNITY DIRECTIVES:</b> The product complies with directives
            (LVD) 2014/35/EU and (EMC) 2014/30/EU
          </p>
      </div>  
      </>
    )
  },
  "ld-250w-bst": {
    name: "LD-250W-BST",
    image: LD3,
    description:(
      <>
      <p>
        <b>Led Controller LD-250W-BST</b> (Booster-Amplifier one channel) was designed to fulfill the needs of illumination control and management of lighting fixtures using LED technology at 12VDC and 24VDC like Led Stripes, Led bulbs, etc. It is a safe and reliable product because it was designed with special integrated circuits and plastic parts for adverse operating conditions.
      </p><br/>
      <p>
        <b>Led Controller LD-250W-BST</b> operation features:
      </p>
      <ul>
        <li>Signal input (PWM) for controlling and adjusting  lighting intensity from other digital systems and lighting regulator (LED CONTROLLERS) having PWM communication protocol.</li>
        <li><b>Input:</b> 12 - 24V DC power supply.</li>
        <li><b>Output:</b> 12 - 24V DC / 21A to the electrical load.</li>
        <li>Function 12V / 250W   Operation 24V / 500W</li>
      </ul><br/>
      <div className="technical-specs">
          <h3>Technical Specifications</h3>
          <p>FUNCTION: Soft - Start</p>
          <p>OPERATING VOLTAGE: 12-24V DC</p>
          <p>OUTPUT POWER: 250 Watt /12V & 500Watt /24V</p><br/>
          <p><b>CONTROL LOAD:</b></p>
          <ul>
            <li>LED lamps (dimmable)</li>
            <li>LED stripes</li>
            <li>Halogen lamps</li>
            <li>Resistive</li>
          </ul><br/>
          <p><b>ENVIRONMENT TEMPERATURE:</b> -20°C until +50°C</p>
          <p>
            <b>FUSE:</b> Electronic fuse for short-circuit protection with automatic
            reset
          </p>
          <p><b>WIRE SIZE:</b> From Ø0.5 mm to Ø3.5 mm</p>
          <p>
            <b>EUROPEAN COMMUNITY DIRECTIVES:</b> The product complies with directives
            (LVD) 2014/35/EU and (EMC) 2014/30/EU
          </p>
      </div>  
      </>
    )
  },
  "ld-rgb-bst": {
    name: "LD-RGB-BST",
    image: LD4,
    description:(
      <>
      <p>
        <b>Led Controller LD-RGB-BST</b> (Booster-Amplifier three channels) was designed to fulfill the needs of illumination control and management of lighting fixtures using LED technology at 12VDC and 24VDC like Led Stripes, Led bulbs, etc. It is a safe and reliable product because it was designed with special integrated circuits and plastic parts for adverse operating conditions.
      </p><br/>
      <p>
        <b>Led Controller LD-RGB-BST</b> operation features:
      </p>
      <ul>
        <li>Signal input (PWM) for controlling and adjusting  lighting intensity from other digital systems and lighting regulator (LED CONTROLLERS) having PWM communication protocol.</li>
        <li><b>Input:</b> 12 - 24V DC power supply.</li>
        <li><b>Output:</b> 12 - 24V DC / 3*8 A to the electrical load.</li>
        <li>Function 12V / 250W   Operation 24V / 500W</li>
      </ul><br/>
      <div className="technical-specs">
          <h3>Technical Specifications</h3>
          <p>FUNCTION: Soft - Start</p>
          <p>OPERATING VOLTAGE: 12-24V DC</p>
          <p>OUTPUT POWER: 3*8 A</p><br/>
          <p><b>CONTROL LOAD:</b></p>
          <ul>
            <li>LED lamps (dimmable)</li>
            <li>LED stripes</li>
            <li>Halogen lamps</li>
            <li>Resistive</li>
          </ul><br/>
          <p><b>ENVIRONMENT TEMPERATURE:</b> -20°C until +50°C</p>
          <p>
            <b>FUSE:</b> Electronic fuse 3*8 A for short-circuit protection with automatic
            reset
          </p>
          <p><b>WIRE SIZE:</b> From Ø0.5 mm to Ø3.5 mm</p>
          <p>
            <b>EUROPEAN COMMUNITY DIRECTIVES:</b> The product complies with directives
            (LVD) 2014/35/EU and (EMC) 2014/30/EU
          </p>
      </div>  
      </>
    )
  },
  "ld-rgb": {
    name: "LD-RGB",
    image: LD5,
    description:(
      <>
      <p>
        <b>Led Controller LD-RGB</b> was designed to fulfill the needs of illumination control and management of lighting fixtures using LED technology at 12VDC and 24VDC like Led Stripes and R-G-B projectors. It is a safe and reliable product because it was designed with special integrated circuits and plastic parts for adverse operating conditions.
      </p><br/>
      <p>
        <b>Led Controller LD-RGB</b> operation features:
      </p>
      <ul>
        <li>Control with one or more parallel buttons for adjusting the lighting intensity (ON / OFF by briefly pressing the button and stretch the lighting - Dimming with a long press).</li>
        <li>Control  through other systems and lighting regulators having communication protocol 1-10V</li>
        <li><b>Input:</b> 12 - 24V DC power supply.</li>
        <li><b>Output:</b> 12 - 24V DC / 21 A to the electrical load.</li>
        <li>Function 12V / 250W   Operation 24V / 500W</li>
      </ul><br/>
      <p><b> Button Control</b></p>
      <ul>
        <li>ON/OFF: Briefly pressing the button</li>
        <li>DIMMING: Long pressing the button</li>
        <li>Lighting Colour Selection: Briefly pressing the button twice the LD-RGB starts rolling all the possible combinations. Briefly pressing the button once again we are choosing the desirable combination of R-G-B and the Controller resets  in dimming operation.</li>
      </ul>
      <div className="technical-specs">
          <h3>Technical Specifications</h3>
          <p>FUNCTION: Soft - Start</p>
          <p>OPERATING VOLTAGE: 12-24V DC</p>
          <p>OUTPUT POWER: 3*8 A</p><br/>
          <p><b>CONTROL LOAD:</b></p>
          <ul>
            <li>LED projectors</li>
            <li>LED stripes</li>
          </ul><br/>
          <p><b>ENVIRONMENT TEMPERATURE:</b> -20°C until +50°C</p>
          <p>
            <b>FUSE:</b> Electronic fuse 3*8 A for short-circuit protection with automatic
            reset
          </p>
          <p><b>WIRE SIZE:</b> From Ø0.5 mm to Ø3.5 mm</p>
          <p>
            <b>EUROPEAN COMMUNITY DIRECTIVES:</b> The product complies with directives 73/23/EEC about low voltage, 89/336/EEC about electromagnetic compliance (EMC)
          </p>
      </div>  
      </>
    )
  },
  "dm-400l-n": {
    name: "DM-400L/N",
    image: DM1,
    description:(
      <>
      <p><b>The DM-400L/N (Dimmer)</b> is an innovative digital technology product (Phase-cut) with switchable Leading Edge - Trailing Edge operation.</p>
      <p>
        It fully meets the needs of light intensity adjustment and energy saving, especially when using alternative LED Filament, LED Dimmable, CFL, Halogen lamps and Dimmable Drivers.

It is an absolutely safe, reliable, and aesthetically elegant product made with special state-of-the-art integrated circuits and durable plastic parts for challenging operating and usage conditions.

Its operation locally from the device and remotely from one or more parallel-connected push buttons of any type and manufacturer makes it unique.
      </p><br/>
      <div className="technical-specs">
          <h3>Technical Specifications</h3>
          <p><b>LIGHTING CONTROLLER:</b> Digital (IGBT) - LED / 1 Channel</p>
          <p><b>OPERATING VOLTAGE:</b> 180 – 230V AC</p>
          <p><b>OPERATING FREQUENCY:</b> 50Hz</p>
          <p><b>OUTPUT POWER:</b> 400W (max)</p>
          <p><b>STANDBY POWER CONSUMPTION:</b> ≦ 1 Watt</p>
          <br/><p><b>OPERATION:</b> Soft-Start</p>
          <p><b>OPERATION (Phase-Cut):</b> Leading – Trailing Edge (Operation mode switching with extended 6 sec button press)</p>
          <p><b>MOUNTING:</b> In switch box with 40mm depth</p>
          <p><b>SAFETY:</b> Electronic protection against overvoltage and overheating with automatic reset to operating state.</p>
          <p><b>TEMPERATURE CONDITIONS:</b> Operating temperature -20°C to +50°C Storage temperature -20°C to +60°C</p>
          <p><b>WIRE SIZE:</b> ∅1mm to ∅2.5mm</p>
          <br/><p><b>Operation:</b></p>
          <p>The <b>Dimmer DM-400L/N</b> has the following control features:</p>
          <ul>
            <li>Rotary potentiometer for light intensity adjustment with integrated (ON/OFF) button for switching the lighting on and off</li>
            <li>Input for wired remote control from one or more parallel-connected push buttons of any type and manufacturer.</li>
          </ul><br/>
          <p><b>Operation Mode Selection (Phase-Cut Dimming):</b></p>
          <ul>
            <li>The DM-400L/N with Phase-Cut Dimming operation gives you the ability to select between Leading Edge and Trailing Edge operation according to the type of electrical load you have installed.</li>
            <li>The selection between Leading Edge - Trailing Edge operation and vice versa is achieved by pressing and holding the device's integrated ON/OFF button for 6 seconds.</li>
          </ul><br/>
          <p><b>Connection:</b></p>
          <ul>
            <li> Without Neutral.<br/>
Connection recommended for any electrical application using dimmable LED lamps.</li>
<li>With Neutral.<br/>
This connection is optional and is applied in areas where the 230VAC / 50Hz electrical network is unstable.</li>
          </ul>
      </div>

      </>
    )
  },
  "dm-1000w": {
    name: "DM-1000W",
    image: DM2,
    description:(
      <>
      <p><b> DM-1000W </b> wall mounting dimmer wasdesigned to cover the needs on lighting and ventilation control on house and partly professional fields. It is an absolutely safe, reliable and good looking product manufactured with special integrated circuits and good quality, resistant plastic parts for cases of function and use under adverse conditions, equipped with one of the best antiparasitic systems.
      </p><br/>
      <p><b>Control:</b></p>
      <p><b>DM-1000W</b> wall mounting dimmer is equipped with a rotary potentiometer (for lighting intensity increase/decrease) with embedded button (ON – OFF) for its function to activate and deactivate.</p>
      <br/><p><b>Lower level setting:</b></p>
      <p><b>DM-1000W</b> has the ability to adjust the minimum level of output power so that it can be used to control electric single phase motors, in which it is essential to prevent the dimmer from delivering less power than it is necessary to turn the motor on. This specific procedure is succeeded by adjusting a potentiometer which is found on the product’s side.</p>
      <div className="technical-specs">
          <h3>Technical Specifications</h3>
          <br/><p><b>Dimmer:</b> MULTI - ALLERETOUR </p>
          <p><b>Operating voltage:</b> 180 – 230V AC</p>
          <p><b>Power line frequency:</b> 50Hz</p>
          <p><b>Output Power:</b> 1000 Watt </p>
          <br/><p><b>CONTROL LOAD:</b></p>
          <ul>
            <li>Halogen lamps</li>
            <li>Resistive Magnetic transformers</li>
            <li>Electronic transformers</li>
            <li>Electric single-phase motors :</li>
          </ul><br/>
          <p><b>ENVIRONMENT TEMPERATURE:</b> -20°C until +50°C</p>
          <p>
            <b>FUSE:</b> 6 A / 230VAC (for short-circuit protection)
          </p>
          <p><b>WIRE SIZE:</b> From Ø0.5 mm to Ø3.5 mm</p>
          <p><b>Mounting: </b>Electrical switch box</p>
          <p>
            <b>EUROPEAN COMMUNITY DIRECTIVES:</b> The product complies with directives:
Low Voltage Directive: 2014/55/EU
EMC Directive: 2014/30/EU
          </p>
      </div>
    </>        
    )        
  },
  "dm-400b": {
    name: "DM-400B",
    image: DM3,
    description:(
      <>
      <p><b> DM-400B </b> (Lighting Controller) is an innovative product of digital technology Leading Edge & Trailing Edge, specially created to fully cover the needs for regulation of lighting intensity and for energy saving, using alternative type of lamps such as LED (dimmable LED), economy lamps (dimmable CFL ) and previous generation light bulbs (Resistive - Halogen).
      </p>
      <p>It is a totally safe, reliable, and aesthetically shaped product made of special integrated circuits of cutting-edge technology and of resistant plastic parts for difficult conditions of operation and usage.</p><br/>
      <p><b>Handling:  Dimmer-400B </b>operation features: </p>
      <p>Input for wired remote control from one or more parallel buttons for adjusting the lighting intensity (ON / OFF by briefly pressing the button and stretch the lighting - Dimming with a long press).</p>
      <br/><p><b>Function selection:</b></p>
      <p>Leading Edge to Trailing Edge and conversely is accomplished by  long pressing  the button for more than  fifteen (15) seconds.</p>
      <br/><p><b>Lowest threshold setting:</b></p>
      <p><b>DM-400B </b>enables the user to preconfigure the minimum point of brightness for Dimmable Led lamps, if required. This process is achieved by adjusting a potentiometer (trimmer) located on the product.</p>
      <div className="technical-specs">
          <h3>Technical Specifications</h3>
          <br/><p><b>Dimmer:</b> IGBT – Digital </p>
          <p><b>FUnction: </b>Soft Start</p>
          <p><b>Operating voltage:</b> 180 – 230V AC</p>
          <p><b>Power line frequency:</b> 50Hz</p>
          <p><b>Output Power:</b> 400 Watt </p>
          <br/><p><b>CONTROL LOAD:</b></p>
          <ul>
            <li>LED lamps (dimmable)</li>
            <li>CFL lamps (dimmable)</li>
            <li>Halogen lamps</li>
            <li>Resistive Magnetic transformers</li>
            <li>Electronic transformers</li>
            <li>Electric single-phase motors :</li>
          </ul><br/>
          <p><b>ENVIRONMENT TEMPERATURE:</b> -20°C until +50°C</p>
          <p>
            <b>FUSE:</b>  Electronic protection against short-circuit, overheating and overvoltage 
          </p>
          <p><b>WIRE SIZE:</b> From Ø0.5 mm to Ø3.5 mm</p>
          <p><b>Mounting: </b>Electrical switch box</p>
          <p>
            <b>EUROPEAN COMMUNITY DIRECTIVES:</b> The product complies with directives:
Low Voltage Directive: 2014/55/EU
EMC Directive: 2014/30/EU
          </p>
      </div>
    </>        
    )
  },
  "dm-400b-rf": {
    name: "DM-400B-RF",
    image: DM4,
    description:(
      <>
      <p><b> DM-400B-RF </b> (Lighting Controller) is an innovative product of digital technology Leading Edge & Trailing Edge, specially created to fully cover the needs for regulation of lighting intensity and for energy saving, using alternative type of lamps such as LED (dimmable LED), economy lamps (dimmable CFL ) and previous generation light bulbs (Resistive - Halogen).
      </p>
      <p>It is a totally safe, reliable, and aesthetically shaped product made of special integrated circuits of cutting-edge technology and of resistant plastic parts for difficult conditions of operation and usage.</p><br/>
      <p><b>Handling:  Dimmer-400B-RF </b>operation features: </p>
      <p>Input for wired remote control from one or more parallel buttons for adjusting the lighting intensity (ON / OFF by briefly pressing the button and stretch the lighting - Dimming with a long press).</p>
      <br/><p><b>Function selection:</b></p>
      <p>Leading Edge to Trailing Edge and conversely is accomplished by  long  pressing  the button for more than  fifteen (15) seconds.</p>
      <br/><p><b>Lowest threshold setting:</b></p>
      <p><b>DM-400B-RF </b>enables the user to preconfigure the minimum point of brightness for Dimmable Led lamps, if required. This process is achieved by adjusting a potentiometer (trimmer) located on the product.</p>
      <div className="technical-specs">
          <h3>Technical Specifications</h3>
          <br/><p><b>Dimmer:</b> IGBT – Digital </p>
          <p><b>Function: </b>Soft Start</p>
          <p><b>Operating voltage:</b> 180 – 230V AC</p>
          <p><b>Power line frequency:</b> 50Hz</p>
          <p><b>Output Power:</b> 400 Watt </p>
          <br/><p><b>CONTROL LOAD:</b></p>
          <ul>
            <li>LED lamps (dimmable)</li>
            <li>CFL lamps (dimmable)</li>
            <li>Halogen lamps</li>
            <li>Resistive Magnetic transformers</li>
            <li>Electronic transformers</li>
            <li>Electric single-phase motors :</li>
          </ul><br/>
          <p><b>ENVIRONMENT TEMPERATURE:</b> -20°C until +50°C</p>
          <p>
            <b>FUSE:</b>  Electronic protection against short-circuit, overheating and overvoltage 
          </p>
          <p><b>WIRE SIZE:</b> From Ø0.5 mm to Ø3.5 mm</p>
          <p><b>Mounting: </b>Electrical switch box</p>
          <p>
            <b>EUROPEAN COMMUNITY DIRECTIVES:</b> The product complies with directives:
Low Voltage Directive: 2014/55/EU
EMC Directive: 2014/30/EU
          </p>
      </div>
    </>        
    )
  },
  "dm-300-b": {
    name: "DM-300/b",
    image: DM5,
    description:(
      <>
      <p><b>DM-300/b </b>rail mounting digital dimmer (light adjuster) is an innovative product of digital technology Leading edge & Trailing edge, especially designed to fulfill the needs of professional spaces in the important field of lighting adjustment and energy savings.</p>
      <p>Its perfect linearity in lighting adjustment with alternative types of lamps such as Filament LED, Dimmable LED, Dimmable CFL and previous technology lamps (HALOGEN) makes this product unique.</p>
      <p>The product can be remotely controlled through one or several distant buttons (any type or company). The output power of the product can be expanded indefinitely by adding amplifiers DM-CHL (1000W per amplifier) thereby making any electrical application possible.</p>
      <br/><p><b>Control:</b></p>
      <p><b>DM-300/b</b> rail-mounting dimmer has 3 buttons for control and a remote control input:</p>
      <ul>
        <li>Button: (ON/OFF) It is used to activate and de-activate the electric load.</li>
        <li>Button: (+ & -) They are used to adjust the lighting intensity and therefore the consumption of the load at the desired point for the operator, from 1% to 100%.</li>
        <li>Input for wired remote control from one or more parallel buttons for adjusting the lighting intensity.</li>
      </ul><br/>
      <p><b>(Phase-Cut Dimming):</b></p>
      <p>The <b>DM-300/b</b> enables the user select the type of Phase-Cut Dimming according to the load Leading Edge and Trailing Edge.</p> 
      <p>In order to select Leading Edge or Trailing Edge long press for 6 sec the following buttons on the device:</p> 
      <ul>
        <li><b>Leading Edge:</b> (+) and (ON/OFF) The LED indicator will flash <b>GREEN.</b>.</li>
        <li><b>Trailing Edge:</b> (-) and (ON/OFF) The LED indicator will flash <b>RED.</b></li>
      </ul><br/>
      <p><b>Adjustment of minimum power limit:</b></p>
      <p>The <b>Dimmer DM-300/b</b> an adjust the lower threshold of the lightning intensity of the Dimmable LED lamps if it's required. This takes place as follows:</p>
      <ul>
        <li><b>Step 1.</b> Long press the ON/OFF for 6 sec and the LED indicator of the DM- 300/b will start blinking orange.</li>
        <li><b>Step 2.</b>Press up (+) or down (-) to adjust the lower threshold of the Dimmable LED lamps.</li>
        <li><b>Step 3.</b>Press the button ON/OFF briefly once to save the adjustment.</li>
      </ul><br/>
      <div className="technical-specs">
          <h3>Technical Specifications</h3>
          <br/><p><b>RAIL-MOUNTED DIMMER 1 MODULE:</b> Digital (IGBT) - LED / 1 Channel </p>
          <p><b>Function: </b>Soft Start</p>
          <p><b>Operating voltage:</b> 180 – 230V AC</p>
          <p><b>Power line frequency:</b> 50Hz</p>
          <p><b>Output Power:</b> The output power of the product can be expanded by adding amplifiers DM-BST/R (1000W per amplifier) </p>
          <p><b>STAND BY CONSUMPTION:</b> ≤ 1W</p><br/>
          <p><b>TEMPERATURE CONDITIONS:</b></p> 
          <p>Operation : -20°C until +50°C</p>
          <p>Storage : -20°C to +60°C</p>
          <p>
            <b>FUSE:</b>  Electronic protection against overheating and overvoltage with automatic reset in operational mode. </p>
          <p><b>WIRE SIZE:</b> From Ø0.5 mm to Ø3.5 mm</p>
          <p><b>Mounting: </b>Din-rail mounting 35x7.5mm (DIN 45277)</p>
          <p>
            <b>EUROPEAN COMMUNITY DIRECTIVES:</b> The product complies with directives:
Low Voltage Directive: 2014/55/EU
EMC Directive: 2014/30/EU
          </p>
      </div>
      </>
    )
  },
  "dm-dgl-b": {
    name: "DM-DGL/b",
    image: DM6,
    description:(
      <>
      <p><b> DM-DGL/b </b> rail mounting digital dimmer  is an innovative product of the digital technology, especially designed to fulfill the needs of professional spaces in the important field of lighting adjustment and energy savings. Its perfect linearity in lighting adjustment with alternative types of lamps such as  Dimmable LED, Dimmable CFL and previous technology lamps (RESISTIVE & HALOGEN) makes this product unique. The product can be remotely controlled through one or several distant buttons.
      </p>
      <br/><p><b>Handling:  DM-DGL/b </b>rail mounting digital dimmer has 3 buttons for control and a remote control input. </p>
      <ul>
        <li><b>Button 1:</b> It is used to activate and de-activate the electric load..</li>
        <li><b>Button 2 and 3:</b> They are used to adjust the lighting intensity and therefore the consumption of the load at the desired point for the operator, from 1% to 100%.</li>
        <li><b>Input</b> for wired remote control from one or more parallel buttons for adjusting the lighting intensity (ON / OFF by briefly pressing the button and stretch the lighting - Dimming with a long press).</li>    
      </ul><br/>
      <p><b>Adjustment of minimum power limit:</b></p>
      <p>The <b>Dimmer DM-DGL/b</b> provides the capacity to also control loads from single-phase electric motors. Therefore, it is necessary to control the lower engine speed of the electric motor in order to avoid its overheating and thus its destruction.</p>
      <ul>
        <li><b>Step 1.</b> Keep the button No 1 (ON / OFF) pressed.</li>
        <li><b>Step 2.</b>While the button No 1 is pressed, adjust the engine speed of the electric motor with buttons No 2 & No 3 (UP / DOWN) at the lowest allowed threshold.</li>
        <li><b>Step 3.</b>Release button No 1 (ON / OFF) and the adjustment is complete. To readjust the lowest threshold the same process must be repeated.</li>
      </ul><br/>
      <div className="technical-specs">
          <h3>Technical Specifications</h3>
          <br/><p><b>Dimmer:</b> Electronic – Digital </p>
          <p><b>Operating voltage:</b> 180 – 230V AC</p>
          <p><b>Operating frequency:</b> 50Hz</p>
          <p><b>Output Power:</b> 1000 Watt </p>
          <br/><p><b>CONTROL LOAD:</b></p>
          <ul>
            <li>LED </li>
            <li>Resistive & Halogen</li>
            <li>Inductive Transformers</li>
            <li>Electronic transformers</li>
            <li>Electric single-phase motors :</li>
          </ul><br/>
          <p><b>ENVIRONMENT TEMPERATURE:</b> -20°C until +50°C</p>
          <p>
            <b>FUSE:</b>  6 A / 230VAC (for short-circuit protection)  
          </p>
          <p><b>WIRE SIZE:</b> From Ø0.5 mm to Ø3.5 mm</p>
          <p><b>Mounting: </b>Din-rail mounting 35 x 7.5 mm (DIN 45277)</p>
          <p>
            <b>EUROPEAN COMMUNITY DIRECTIVES:</b> The product complies with directives:
Low Voltage Directive: 2014/55/EU
EMC Directive: 2014/30/EU
          </p>
      </div>
    </>        
    )
  },
  "dm-2500w": {
    name: "DM-2500W",
    image: DM7,
    description:(
      <>
      <p><b> Dimmer DM-2500 </b>was designed to cover the needs of professional stores on basic sections oflighting and ventilation. It is an absolutely safe to use and reliable product as it isconstructed with special integrated circuits and tough plastic so it can function under adverse conditions.
      </p>
      <br/><p><b>Control: Dimmer DM-2500 </b>is controlled by a a rotary potentiometer which controls the current and the power consumption to the desired level from 1% to 100%. The is also an embedded switch in the potentiometer (press switch) to activate and deactivate the device.</p>
      <br/><p><b>Lower level setting :</b></p>
      <p>As it is mentioned at the technical characteristics topic, DM - 2500 has the ability to adjust the minimum level of output power so that it can be used to control electric single phase motors, in which it is essential to prevent the dimmer from delivering less power than it is necessary to turn the motor on. This specific procedure is succeeded by adjusting a potentiometer which is found inside the product.</p>
      <br/><ul>
        <li><b>Step 1.</b> Set the main potentiometer at lowest setting.</li>
        <li><b>Step 2.</b>Meanwhile, remove the mask of the device (DM - 2500) and then set the potentiometer which is inside the dimmer (ADJ) to the lowest allowed desired limit.</li>
        <li><b>Step 3.</b> Repeat the same procedure in order to reset the lowest limit.</li>
      </ul><br/>
      <div className="technical-specs">
          <h3>Technical Specifications</h3>
          <br/><p><b>Dimmer:</b> Electronic – Digital </p>
          <p><b>Operating voltage:</b> 180 – 230V AC</p>
          <p><b>Operating frequency:</b> 50Hz</p>
          <p><b>Maximum Output Power:</b> 2500 Watt </p>
          <br/><p><b>CONTROL LOAD:</b></p>
          <ul>
            <li>LED </li>
            <li>Resistive & Halogen</li>
            <li>Inductive Transformers</li>
            <li>Electronic transformers</li>
            <li>Electric single-phase motors :</li>
            <br/><ol>
              <li>Universal</li>
              <li>Asynchronous with torque strongly depended from motor speed (centrifugal pumps, fans, ventilations).</li>
            </ol>
          </ul><br/>
          <p><b>ENVIRONMENT TEMPERATURE:</b> -20°C until +50°C</p>
          <p>
            <b>FUSE:</b>  15 A / 230VAC (for short-circuit protection)  
          </p>
          <p><b>WIRE SIZE:</b> From Ø0.5 mm to Ø3.5 mm</p>
          <p><b>Fixing: </b>Surface Mounting</p>
          <p>
            <b>EUROPEAN COMMUNITY DIRECTIVES:</b> The product complies with directives:
Low Voltage Directive: 2014/55/EU
EMC Directive: 2014/30/EU
          </p>
      </div>
    </>        
    )
  },
  "dm-2500": {
    name: "DM-2500",
    image: DM8,
    description:(
      <>
      <p><b> Dimmer DM-2500 </b>was designed to cover the needs of professional stores on basic sections oflighting and ventilation. It is an absolutely safe to use and reliable product as it isconstructed with special integrated circuits and tough plastic so it can function under adverse conditions.
      </p>
      <br/><p><b>Control: Dimmer DM-2500 </b>is controlled by a a rotary potentiometer which controls the current and the power consumption to the desired level from 1% to 100%. The is also an embedded switch in the potentiometer (press switch) to activate and deactivate the device.</p>
      <br/><p><b>Lower level setting :</b></p>
      <p>As it is mentioned at the technical characteristics topic, DM - 2500 has the ability to adjust the minimum level of output power so that it can be used to control electric single phase motors, in which it is essential to prevent the dimmer from delivering less power than it is necessary to turn the motor on. This specific procedure is succeeded by adjusting a potentiometer which is found inside the product.</p>
      <br/><ul>
        <li><b>Step 1.</b> Set the main potentiometer at lowest setting.</li>
        <li><b>Step 2.</b>Meanwhile, remove the mask of the device (DM - 2500) and then set the potentiometer which is inside the dimmer (ADJ) to the lowest allowed desired limit.</li>
        <li><b>Step 3.</b> Repeat the same procedure in order to reset the lowest limit.</li>
      </ul><br/>
      <div className="technical-specs">
          <h3>Technical Specifications</h3>
          <br/><p><b>Dimmer:</b> Electronic – Digital </p>
          <p><b>Operating voltage:</b> 180 – 230V AC</p>
          <p><b>Operating frequency:</b> 50Hz</p>
          <p><b>Maximum Output Power:</b> 2500 Watt </p>
          <br/><p><b>CONTROL LOAD:</b></p>
          <ul>
            <li>LED </li>
            <li>Resistive & Halogen</li>
            <li>Inductive Transformers</li>
            <li>Electronic transformers</li>
            <li>Electric single-phase motors :</li>
            <br/><ol>
              <li>Universal</li>
              <li>Asynchronous with torque strongly depended from motor speed (centrifugal pumps, fans, ventilations).</li>
            </ol>
          </ul><br/>
          <p><b>ENVIRONMENT TEMPERATURE:</b> -20°C until +50°C</p>
          <p>
            <b>FUSE:</b>  15 A / 230VAC (for short-circuit protection)  
          </p>
          <p><b>WIRE SIZE:</b> From Ø0.5 mm to Ø3.5 mm</p>
          <p><b>Fixing: </b>Surface Mounting</p>
          <p>
            <b>EUROPEAN COMMUNITY DIRECTIVES:</b> The product complies with directives:
Low Voltage Directive: 2014/55/EU
EMC Directive: 2014/30/EU
          </p>
      </div>
    </>        
    )
  },
  "dm-pro-1-10v": {
    name: "DM-PRO 1-10V",
    image: DM9,
    description:(
      <>
      <p><b> Dimmer DM-PRO 1-10V </b>was designed to cover the needs of professional stores on basic sections of lighting.The modern design combined with the advantages of technology 1-10V, which is widening in the field of professional lighting, makes it unique. It is an absolutely safe to use and reliable product as it is constructed with special integrated circuits and tough plastic so it can function under adverse conditions.
      </p>
      <br/><p><b>Handling: Dimmer DM-PRO 1-10V </b>is controlled by a rotary potentiometer which controls the current and the power consumption to the desired level from 1% to 100%. The is also an embedded switch in the potentiometer (press switch) to activate and deactivate the device.</p>
      <br/><p><b>Lower level setting :</b></p>
      <p><b>Dimmer DM-PRO 1-10V</b>gives us the ability to pre-configure the minimum lamp brightness point if required. This process is accomplished by adjusting a potentiometer (trimmer) located inside the device.</p>
      <br/><ul>
        <li><b>Step 1.</b> Set the main potentiometer at lowest setting.</li>
        <li><b>Step 2.</b>Meanwhile, remove the mask of the device (DM-PRO 1-10V) and then set the potentiometer which is inside the dimmer (ADJ) to the lowest allowed desired limit.</li>
        <li><b>Step 3.</b> Repeat the same procedure in order to reset the lowest limit.</li>
      </ul><br/>
      <div className="technical-specs">
          <h3>Technical Specifications</h3>
          <br/><p><b>Dimmer:</b> Electronic  1-10V </p>
          <p><b>Operation: </b>Soft Start</p>
          <p><b>Operating voltage:</b> 230V AC</p>
          <p><b>Operating frequency:</b> 50Hz</p>
          <p><b>Output Signal:</b> 1-10V / 50 mA </p>
          <p><b>Fuse:</b>6,3 A (for short-circuit protection)</p>
          <p><b>Setting: Rotary Potentiometer</b></p>
          <p><b>Lower Limit Setting:</b>Internal Potentiometer (trimmer) </p>
          <br/>
          <p><b>ENVIRONMENT TEMPERATURE:</b> -20°C until +50°C</p>
          <p><b>WIRE SIZE:</b> From Ø0.5 mm to Ø3.5 mm</p>
          <p><b>Mounting: </b>Surface Mounting</p>
          <p>
            <b>EUROPEAN COMMUNITY DIRECTIVES:</b> The product complies with directives:
Low Voltage Directive: 2014/55/EU
EMC Directive: 2014/30/EU
          </p>
      </div>
    </>        
    )
  },
};

// ================== COMPONENT ==================
const ProductDetail = () => {
  const { productId } = useParams();
  const product = productData[productId];
  const [isZoomed, setIsZoomed] = useState(false);

  useEffect(() => {
  window.scrollTo(0, 0);
}, []);

  if (!product) {
    return (
      <div className="product-detail-container">
        <h2>Product Not Found</h2>
        <Link to="/k-watt-electric/products" className="back-button">
          Back to Products
        </Link>
      </div>
    );
  }

  return (
    <div className="product-detail-container">
      <div className="product-detail-content">
        <img src={product.image} alt={product.name} className="main-image" onClick={() => setIsZoomed(true)}/>
        <div className="product-detail-text">
          <h2>{product.name}</h2>

          {/* ✅ FIXED: use div, not p */}
          <div>{product.description}</div>

          <Link 
  to="/products"
  className="back-button"
  onClick={() => window.scrollTo(0, 0)}
>
            ← Back to Products
          </Link>
        </div>
      </div>
      {isZoomed && (
        <div className="zoom-overlay" onClick={() => setIsZoomed(false)}>
          <button
      className="close-zoom-btn"
      onClick={() => setIsZoomed(false)}
      aria-label="Close"
    >
      ✖
    </button>
          <img
            src={product.image}
            alt={product.name}
            className="zoomed-image"
            onClick={(e) => e.stopPropagation()} // prevent closing when clicking image
          />
        </div>
      )}
    </div>
  );
};

export default ProductDetail;
